/** @format */
import textWithDefaultMissingValueTpl from './textWithDefaultMissingValue.tpl.html';

export const textWithDefaultMissingValueModule = 'sis-components.applications.textWithDefaultMissingValue';

(function () {
    angular.module(textWithDefaultMissingValueModule, []).component('textWithDefaultMissingValue', {
        bindings: {
            isOption: '<?',
            value: '<?',
            valueKey: '<?',
        },
        template: textWithDefaultMissingValueTpl,
        controller: [
            '$translate',
            function ($translate) {
                var ctrl = this;

                this.$onChanges = function () {
                    ctrl.renderedValue = ctrl.value || $translate.instant(ctrl.valueKey);
                    ctrl.hasValue = !!ctrl.renderedValue;
                    ctrl.missingValue = ctrl.isOption ? '-' : $translate.instant('STUDENT_APPLICATIONS.INFO_MISSING');
                };
            },
        ],
    });
})();
